t = require('views/internal/teacup-with-helpers')('archived_cards')

module.exports = ->
  t.p '.too-many-results-message.helper.js-search-message.hide'

  t.div '.js-archive-items'

  t.p '.empty-list.js-empty-message'

  t.a '.show-more.js-more-cards', { href: '#' }, ->
    t.format 'load-more-cards'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/archived_cards.coffee